<template>
	<div id="backtop">
		<el-backtop></el-backtop>
	</div>
</template>

<script>
	export default{
		name:'backtop',
		data(){
			return{
				
			}
		},
		methods:{
		}
	}
</script>

<style scoped>

</style>